module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newBounce"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_vm._v("APP首页弹框管理 >\n\t\t"), (_vm.edit === false) ? _c('span', [_vm._v("新增")]) : _vm._e(), _vm._v(" "), (_vm.edit !== false) ? _c('span', [_vm._v("编辑")]) : _vm._e(), _vm._v(" "), _c('span', [_c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('el-form', {
    ref: "bounceForm",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.bounceForm,
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "弹框名称:",
      "prop": "name"
    }
  }, [_c('el-input', {
    staticClass: "bounceTitle",
    attrs: {
      "placeholder": "名称仅用做后台管理，不会展现在APP上，选填"
    },
    model: {
      value: (_vm.bounceForm.name),
      callback: function($$v) {
        _vm.$set(_vm.bounceForm, "name", $$v)
      },
      expression: "bounceForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "弹框类型:",
      "prop": "bounceType",
      "required": ""
    }
  }, [_c('el-select', {
    staticClass: "bounceZhouqi",
    model: {
      value: (_vm.bounceForm.bounceType),
      callback: function($$v) {
        _vm.$set(_vm.bounceForm, "bounceType", $$v)
      },
      expression: "bounceForm.bounceType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "常规弹框",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "不规则弹框",
      "value": "1"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "常规弹框图片",
      "prop": "imgUrl"
    }
  }, [_c('el-upload', {
    attrs: {
      "action": _vm.actionUrl,
      "with-credentials": true,
      "accept": "image/*",
      "name": "uploadFile",
      "type": "drag",
      "thumbnail-mode": true,
      "on-error": _vm.handleError,
      "on-success": _vm.handleSuccess
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-dragger__text"
  }, [_vm._v("将文件拖到此处，或\n\t\t\t\t\t\t"), _c('em', [_vm._v("点击上传")])])])], 1), _vm._v(" "), (_vm.bounceForm.bounceType == '1') ? _c('el-form-item', {
    attrs: {
      "label": "不规则弹框图片",
      "prop": "irregularImgUrl",
      "required": ""
    }
  }, [_c('el-upload', {
    attrs: {
      "action": _vm.actionUrl,
      "with-credentials": true,
      "accept": "image/*",
      "name": "uploadFile",
      "type": "drag",
      "thumbnail-mode": true,
      "on-error": _vm.handleError,
      "on-success": _vm.handleSuccess_irreg
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-dragger__text"
  }, [_vm._v("将文件拖到此处，或\n\t\t\t\t\t\t"), _c('em', [_vm._v("点击上传")])])])], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "弹框主标题:",
      "prop": "mainTitle"
    }
  }, [_c('el-input', {
    staticClass: "bounceTitle",
    attrs: {
      "placeholder": "请填写正确的主标题，不超过16个字符"
    },
    model: {
      value: (_vm.bounceForm.mainTitle),
      callback: function($$v) {
        _vm.$set(_vm.bounceForm, "mainTitle", $$v)
      },
      expression: "bounceForm.mainTitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "弹框副标题:",
      "prop": "subTitle"
    }
  }, [_c('el-input', {
    staticClass: "bounceTitle",
    attrs: {
      "placeholder": "请填写正确的副标题，不超过48个字符"
    },
    model: {
      value: (_vm.bounceForm.subTitle),
      callback: function($$v) {
        _vm.$set(_vm.bounceForm, "subTitle", $$v)
      },
      expression: "bounceForm.subTitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "按钮文案:",
      "prop": "btnText"
    }
  }, [_c('el-input', {
    staticClass: "bounceTitle",
    attrs: {
      "placeholder": "查看详情"
    },
    model: {
      value: (_vm.bounceForm.btnText),
      callback: function($$v) {
        _vm.$set(_vm.bounceForm, "btnText", $$v)
      },
      expression: "bounceForm.btnText"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "弹出周期:",
      "prop": "showStatus"
    }
  }, [_c('el-select', {
    staticClass: "bounceZhouqi",
    model: {
      value: (_vm.bounceForm.showStatus),
      callback: function($$v) {
        _vm.$set(_vm.bounceForm, "showStatus", $$v)
      },
      expression: "bounceForm.showStatus"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "每天首次启动APP",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "每次启动APP",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": " 活动期间仅弹出一次",
      "value": "3"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "bounceContent",
    attrs: {
      "label": "广告曝光代码:",
      "prop": "adExposingCodes"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 5
      },
      "placeholder": "在这里粘贴"
    },
    model: {
      value: (_vm.bounceForm.adExposingCodes),
      callback: function($$v) {
        _vm.$set(_vm.bounceForm, "adExposingCodes", $$v)
      },
      expression: "bounceForm.adExposingCodes"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "起止日期:",
      "prop": "qizhiDate",
      "required": ""
    }
  }, [_c('el-form-item', {
    staticClass: "time",
    attrs: {
      "prop": "startTime"
    }
  }, [_c('el-date-picker', {
    staticClass: "qizhiDate",
    attrs: {
      "type": "datetime",
      "placeholder": "yyyy/MM/dd hh:mm:ss"
    },
    model: {
      value: (_vm.bounceForm.startTime),
      callback: function($$v) {
        _vm.$set(_vm.bounceForm, "startTime", $$v)
      },
      expression: "bounceForm.startTime"
    }
  })], 1), _vm._v("\n\t\t\t\t  至  \n\t\t\t\t"), _c('el-form-item', {
    staticClass: "time",
    attrs: {
      "prop": "endTime"
    }
  }, [_c('el-date-picker', {
    staticClass: "qizhiDate",
    attrs: {
      "type": "datetime",
      "placeholder": "yyyy/MM/dd hh:mm:ss"
    },
    model: {
      value: (_vm.bounceForm.endTime),
      callback: function($$v) {
        _vm.$set(_vm.bounceForm, "endTime", $$v)
      },
      expression: "bounceForm.endTime"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "click-events",
    attrs: {
      "label": "点击事件",
      "prop": "clickType"
    }
  }, [_c('el-radio', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.bounceForm.clickType),
      callback: function($$v) {
        _vm.$set(_vm.bounceForm, "clickType", $$v)
      },
      expression: "bounceForm.clickType"
    }
  }, [_vm._v("无跳转")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.bounceForm.clickType),
      callback: function($$v) {
        _vm.$set(_vm.bounceForm, "clickType", $$v)
      },
      expression: "bounceForm.clickType"
    }
  }, [_vm._v("跳转至URL：")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.bounceForm.clickType),
      callback: function($$v) {
        _vm.$set(_vm.bounceForm, "clickType", $$v)
      },
      expression: "bounceForm.clickType"
    }
  }, [_vm._v("跳转至已有文章：")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "3"
    },
    model: {
      value: (_vm.bounceForm.clickType),
      callback: function($$v) {
        _vm.$set(_vm.bounceForm, "clickType", $$v)
      },
      expression: "bounceForm.clickType"
    }
  }, [_vm._v("跳转至已有话题：")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "5"
    },
    model: {
      value: (_vm.bounceForm.clickType),
      callback: function($$v) {
        _vm.$set(_vm.bounceForm, "clickType", $$v)
      },
      expression: "bounceForm.clickType"
    }
  }, [_vm._v("跳转至微信小程序：")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "7"
    },
    model: {
      value: (_vm.bounceForm.clickType),
      callback: function($$v) {
        _vm.$set(_vm.bounceForm, "clickType", $$v)
      },
      expression: "bounceForm.clickType"
    }
  }, [_vm._v("跳转至支付宝小程序：")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "6"
    },
    model: {
      value: (_vm.bounceForm.clickType),
      callback: function($$v) {
        _vm.$set(_vm.bounceForm, "clickType", $$v)
      },
      expression: "bounceForm.clickType"
    }
  }, [_vm._v("跳转至音频：")]), _vm._v(" "), (_vm.shieldArray.indexOf(_vm.bounceForm.clickType) > -1) ? _c('el-input', {
    staticClass: "bounceTitle",
    attrs: {
      "placeholder": _vm.placeholder
    },
    model: {
      value: (_vm.bounceForm.targetUrl),
      callback: function($$v) {
        _vm.$set(_vm.bounceForm, "targetUrl", $$v)
      },
      expression: "bounceForm.targetUrl"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.bounceForm.clickType == '5') ? _c('div', {
    staticClass: "wx-app"
  }, [_c('el-form-item', {
    staticClass: "wxApp-from",
    attrs: {
      "label": "小程序原始Id：",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写正确的小程序原始Id"
    },
    model: {
      value: (_vm.bounceForm.wxAppId),
      callback: function($$v) {
        _vm.$set(_vm.bounceForm, "wxAppId", $$v)
      },
      expression: "bounceForm.wxAppId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "wxApp-from",
    attrs: {
      "label": "路径地址："
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写正确的路径地址"
    },
    model: {
      value: (_vm.bounceForm.wxAppUrl),
      callback: function($$v) {
        _vm.$set(_vm.bounceForm, "wxAppUrl", $$v)
      },
      expression: "bounceForm.wxAppUrl"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.bounceForm.clickType == '7') ? _c('div', {
    staticClass: "wx-app"
  }, [_c('el-form-item', {
    staticClass: "wxApp-from",
    attrs: {
      "label": "小程序原始Id：",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写正确的小程序原始Id"
    },
    model: {
      value: (_vm.bounceForm.aliAppId),
      callback: function($$v) {
        _vm.$set(_vm.bounceForm, "aliAppId", $$v)
      },
      expression: "bounceForm.aliAppId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "wxApp-from",
    attrs: {
      "label": "路径地址："
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写正确的路径地址"
    },
    model: {
      value: (_vm.bounceForm.aliAppUrl),
      callback: function($$v) {
        _vm.$set(_vm.bounceForm, "aliAppUrl", $$v)
      },
      expression: "bounceForm.aliAppUrl"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.bounceForm.clickType == '6') ? _c('div', {
    staticClass: "wx-app"
  }, [_c('el-form-item', {
    staticClass: "wxApp-from",
    attrs: {
      "label": "专辑ID：",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写专辑ID"
    },
    model: {
      value: (_vm.bounceForm.albumId),
      callback: function($$v) {
        _vm.$set(_vm.bounceForm, "albumId", $$v)
      },
      expression: "bounceForm.albumId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "wxApp-from wx-app",
    attrs: {
      "label": "主播名称：",
      "prop": "nickName",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写主播名称"
    },
    model: {
      value: (_vm.bounceForm.nickName),
      callback: function($$v) {
        _vm.$set(_vm.bounceForm, "nickName", $$v)
      },
      expression: "bounceForm.nickName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "wxApp-from",
    attrs: {
      "label": "单曲数：",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写单曲数",
      "type": "number"
    },
    model: {
      value: (_vm.bounceForm.albumCount),
      callback: function($$v) {
        _vm.$set(_vm.bounceForm, "albumCount", $$v)
      },
      expression: "bounceForm.albumCount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "wxApp-from",
    attrs: {
      "label": "是否付费：",
      "prop": "isPaid",
      "required": ""
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.bounceForm.isPaid),
      callback: function($$v) {
        _vm.$set(_vm.bounceForm, "isPaid", $$v)
      },
      expression: "bounceForm.isPaid"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.bounceForm.isPaid),
      callback: function($$v) {
        _vm.$set(_vm.bounceForm, "isPaid", $$v)
      },
      expression: "bounceForm.isPaid"
    }
  }, [_vm._v("否")])], 1)], 1) : _vm._e(), _vm._v(" "), (['1', '5', '7'].indexOf(_vm.bounceForm.clickType) > -1) ? _c('div', {
    staticClass: "popup-prompt-wrap"
  }, [_c('el-form-item', {
    attrs: {
      "label": "是否弹窗提示",
      "required": ""
    }
  }, [_c('div', {
    staticClass: "popup-prompt-row"
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.bounceForm.isPopup),
      callback: function($$v) {
        _vm.$set(_vm.bounceForm, "isPopup", $$v)
      },
      expression: "bounceForm.isPopup"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("否")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), (_vm.bounceForm.isPopup === 1) ? _c('el-input', {
    staticClass: "popup-prompt-input",
    attrs: {
      "maxlength": "20",
      "placeholder": "请填写弹窗内容，最多20个字"
    },
    model: {
      value: (_vm.bounceForm.popupContent),
      callback: function($$v) {
        _vm.$set(_vm.bounceForm, "popupContent", $$v)
      },
      expression: "bounceForm.popupContent"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "popup-prompt-example"
  }, [_c('span', {
    staticClass: "popup-prompt-example-label"
  }, [_vm._v("示例")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.popupPromptExampleImg,
      "alt": "弹窗示例"
    }
  })])], 1)])], 1) : _vm._e(), _vm._v(" "), _c('select-school', {
    attrs: {
      "schObj": _vm.bounceForm.schObj,
      "isRoot": _vm.isRoot
    },
    on: {
      "changeVal": _vm.getVal
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f1e9dc28!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/yunying/bounce/newBounce.vue
// module id = 1140
// module chunks = 0